const numberFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const fractionNumberFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'decimal',
    minimumFractionDigits: 2
});
export const formatNumber = (amount) => {
    if (amount % 1 === 0)
        return numberFormatter.format(amount).replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
    else
        return fractionNumberFormatter.format(amount).replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
};
